import { render, staticRenderFns } from "./GameCountCard.vue?vue&type=template&id=b5add19e&"
import script from "./GameCountCard.vue?vue&type=script&lang=js&"
export * from "./GameCountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports